import _getI18n from './i18n';
import I18nContext, {
  I18nProvider as provider,
  I18nConsumer as consumer,
} from './components/I18nContext';
import _I18n from './components/I18n';
import _useI18n from './hooks/useI18n';

export const I18nProvider = provider;
export const I18nConsumer = consumer;
export const I18n = _I18n;
export const useI18n = _useI18n;
export const getI18n = _getI18n;

export default {
  I18nContext,
  I18nProvider,
  I18nConsumer,
  I18n,
  useI18n,
  getI18n,
};
